
import { Heading } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import Footer from './Components/Footer';
import Navbar from './Components/Navbar';
import Navbar1 from './Components/Navbar1';
import AdminHome from './Pages/Admin/AdminHome';
import AdminNav from './Pages/Admin/AdminNav';
import AllRoutes from './Pages/AllRoutes';
import { userInfo } from './Redux/User/action';






function App() {



  return (
   <>

    <Navbar1/>
    <Navbar/>
    <AllRoutes/>
    <Footer/>

   </>
  );
}

export default App;
